module.exports = __webpack_public_path__ + "img/52002763_L.8fe3a516.png";